import { render } from "./FulfillmentPageGuide.vue?vue&type=template&id=2dca4c9e&scoped=true"
import script from "./FulfillmentPageGuide.vue?vue&type=script&lang=js"
export * from "./FulfillmentPageGuide.vue?vue&type=script&lang=js"

import "./FulfillmentPageGuide.vue?vue&type=style&index=0&id=2dca4c9e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dca4c9e"]])

export default __exports__